import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Membership from './pages/Membership';
import CommunityHub from './pages/CommunityHub';
import Activities from './pages/Activities';
import Football from './pages/activities/Football';
import WalkAndTalk from './pages/activities/WalkAndTalk';
import WomensCoffeeMornings from './pages/activities/WomensCoffeeMornings';
import WomensAerobics from './pages/activities/WomensAerobics';
import Cycling from './pages/activities/Cycling';
import MinibusBooking from './pages/MinibusBooking';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/community-hub" element={<CommunityHub />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/activities/football" element={<Football />} />
            <Route path="/activities/walk-and-talk" element={<WalkAndTalk />} />
            <Route path="/activities/womens-coffee-mornings" element={<WomensCoffeeMornings />} />
            <Route path="/activities/womens-aerobics" element={<WomensAerobics />} />
            <Route path="/activities/cycling" element={<Cycling />} />
            <Route path="/minibus-booking" element={<MinibusBooking />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
